import type { IconData } from '@stacksjs/iconify-core'

export const multiply: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7 18a1 1 0 0 1-.707-1.707l10-10a1 1 0 0 1 1.414 1.414l-10 10A1 1 0 0 1 7 18\"/><path fill=\"currentColor\" d=\"M17 18a1 1 0 0 1-.707-.293l-10-10a1 1 0 0 1 1.414-1.414l10 10A1 1 0 0 1 17 18\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default multiply
